<template>
    <!-- `z-99999` DELETED, `z-100` KEPT, and the pair is worth a sentence because it is R1's whole
         genus in one attribute. `z-99999` is not a key on this build — `tailwind.config.js` extends
         `zIndex` with the §3.8 names plus a staged `'100'` — so it emitted nothing, and this header
         has always painted at the `z-100` written after it. Two tokens, one of them decorative, on
         the surface that is on screen every second of a reviewer's shift.

         `z-100` stays because §3.8's ladder is one atomic change: the config comment marks it
         «DELETED once AppHeader.vue and AppShell.vue name a layer instead of a number», and moving
         this to `z-header` (50) without moving `AppShell.vue:37`'s wrapper, the four modals, the
         mobile scrim and `ContextHelp`'s teleported drawer in the same commit reorders overlays that
         currently work. See the note in `ToastBar.vue`; raised as a finding. -->
    <!-- `lg:h-16` — §14.3 move #5, and it makes a standing lie true. `AppShell.vue:51` reserves
         `calc(100vh-4rem)` = 64px for this header and `AppSidebar.vue` offsets itself by `mt-16`,
         while the header measured 68.8px (`lg:py-4` × 2 + a 36px control row + the border). Every page
         in the panel was 5px taller than the shell believed. The height is now declared, and the row
         padding that used to set it drops to `lg:py-0` so the 36px controls centre inside it. -->
    <header
        class="admin-topbar sticky top-0 z-100 flex w-full border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900 lg:h-16 lg:border-b"
    >
        <div class="flex min-w-0 grow flex-col items-center justify-between lg:flex-row lg:gap-4 lg:px-4">
            <div
                class="flex items-center justify-between w-full gap-2 px-3 py-3 border-b border-gray-200 dark:border-gray-800 sm:gap-4 lg:min-w-0 lg:justify-normal lg:border-b-0 lg:px-0 lg:py-0"
            >
                <!-- §3.5: three control heights, and 44px (`lg`) is «a page's single primary action,
                     and the three verdict buttons» — not the chrome that is on every screen. The
                     header row now measures one height, 36px, on every breakpoint: the two icon
                     buttons here, `ThemeToggler`, the bell and the avatar. It used to run 40px, then
                     44px above `lg`, beside a 44px avatar and a 44px toggle. -->
                <button
                    type="button"
                    :class="[isMobileOpen ? 'lg:bg-transparent dark:lg:bg-transparent bg-gray-100 dark:bg-gray-800' : '']"
                    class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border-gray-200 text-gray-500 transition dark:border-gray-800 dark:text-gray-400 lg:border"
                    :aria-label="isMobileOpen ? 'بستنِ منوی کناری' : 'بازکردنِ منوی کناری'"
                    :aria-expanded="isMobileOpen"
                    @click="handleToggle"
                >
                    <svg
                        v-if="isMobileOpen"
                        class="fill-current"
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            clip-rule="evenodd"
                            d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
                            fill=""
                            fill-rule="evenodd"
                        />
                    </svg>

                    <svg
                        v-else
                        fill="none"
                        height="12"
                        viewBox="0 0 16 12"
                        width="16"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            clip-rule="evenodd"
                            d="M0.583252 1C0.583252 0.585788 0.919038 0.25 1.33325 0.25H14.6666C15.0808 0.25 15.4166 0.585786 15.4166 1C15.4166 1.41421 15.0808 1.75 14.6666 1.75L1.33325 1.75C0.919038 1.75 0.583252 1.41422 0.583252 1ZM0.583252 11C0.583252 10.5858 0.919038 10.25 1.33325 10.25L14.6666 10.25C15.0808 10.25 15.4166 10.5858 15.4166 11C15.4166 11.4142 15.0808 11.75 14.6666 11.75L1.33325 11.75C0.919038 11.75 0.583252 11.4142 0.583252 11ZM1.33325 5.25C0.919038 5.25 0.583252 5.58579 0.583252 6C0.583252 6.41421 0.919038 6.75 1.33325 6.75L7.99992 6.75C8.41413 6.75 8.74992 6.41421 8.74992 6C8.74992 5.58579 8.41413 5.25 7.99992 5.25L1.33325 5.25Z"
                            fill="currentColor"
                            fill-rule="evenodd"
                        />
                    </svg>
                </button>
                <HeaderLogo/>
                <button
                    type="button"
                    class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-gray-700 transition hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 lg:hidden"
                    :aria-label="isApplicationMenuOpen ? 'بستنِ ابزارهای بالا' : 'نمایشِ ابزارهای بالا'"
                    :aria-expanded="isApplicationMenuOpen"
                    @click="toggleApplicationMenu"
                >
                    <!-- SVG content -->
                    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                        <path clipRule="evenodd" d="M5.99902 10.4951C6.82745 10.4951 7.49902 11.1667 7.49902 11.9951V12.0051C7.49902 12.8335 6.82745 13.5051 5.99902 13.5051C5.1706 13.5051 4.49902 12.8335 4.49902 12.0051V11.9951C4.49902 11.1667 5.1706 10.4951 5.99902 10.4951ZM17.999 10.4951C18.8275 10.4951 19.499 11.1667 19.499 11.9951V12.0051C19.499 12.8335 18.8275 13.5051 17.999 13.5051C17.1706 13.5051 16.499 12.8335 16.499 12.0051V11.9951C16.499 11.1667 17.1706 10.4951 17.999 10.4951ZM13.499 11.9951C13.499 11.1667 12.8275 10.4951 11.999 10.4951C11.1706 10.4951 10.499 11.1667 10.499 11.9951V12.0051C10.499 12.8335 11.1706 13.5051 11.999 13.5051C12.8275 13.5051 13.499 12.8335 13.499 12.0051V11.9951Z"
                              fill="currentColor"
                              fillRule="evenodd"></path>
                    </svg>
                </button>
                <SearchBar class="header-search"/>

                <!--
                  ══ «where am I», and it costs 0px of height ═════════════════════════════════════
                  Measured before this line existed: this header rendered a hamburger, a theme toggle,
                  a bell and an avatar, and ZERO characters identifying the page or its section. The
                  only place a page named itself was one `<h1>`, with no section, no icon and nothing
                  tying it to the sidebar row the operator clicked. There is no breadcrumb component in
                  `src/` — §5.8 deleted one, correctly: it rendered `text-3xl`, larger than any `<h1>`
                  in the product.

                  ONE mechanism instead of 120. Both halves are read from the same route table the
                  sidebar and the finder read (`../navigation`, `../routeNames`), so the three cannot
                  disagree; a breadcrumb on 120 pages is 120 places to disagree. It sits inside the
                  existing 36px control row, so it adds no height, and the header is `sticky top-0`, so
                  the answer is on screen at every scroll position.

                  It is NOT a link. It answers «where am I», not «where can I go» — the sidebar row is
                  the way back and it already carries `aria-current="page"`.
                -->
                <div
                    v-if="locationLine.length"
                    class="header-breadcrumb hidden min-w-0 items-center gap-1.5 text-xs text-gray-500 dark:text-gray-400 lg:flex"
                    :title="fullLocationLine.join(' › ')"
                    :aria-label="fullLocationLine.join(' › ')"
                    data-testid="header-location"
                >
                    <template v-for="(part, index) in locationLine" :key="part">
                        <span v-if="index" aria-hidden="true" class="text-gray-300 dark:text-gray-600">›</span>
                        <!-- §8.5: every `truncate` carries a `:title`. A clipped section name is a
                             half-answer to «where am I», which is worse than none. -->
                        <span
                            class="truncate"
                            :title="part"
                            :class="index === locationLine.length - 1 ? 'font-medium text-gray-700 dark:text-gray-200' : ''"
                        >{{ part }}</span>
                    </template>
                </div>
            </div>

            <div
                :class="[isApplicationMenuOpen ? 'flex' : 'hidden']"
                class="header-account items-center justify-between w-full gap-3 px-3 py-2 shadow-lg lg:flex lg:w-auto lg:shrink-0 lg:justify-end lg:px-0 lg:py-0 lg:shadow-none"
            >
                <!-- `2xsm:gap-3` named a breakpoint this config does not define, so it emitted
                     nothing (R1). `gap-2` is §3.2's «controls inside a toolbar or a control group». -->
                <div class="header-tools flex items-center gap-1">
                    <!--
                      ══ فضای کار، از هر صفحه‌ای ═══════════════════════════════════════════════════════
                      حالتِ تمرکز از قبل وجود داشت، ولی دکمه‌اش فقط روی «بانکِ سؤال» بود؛ یعنی کسی که
                      تمامِ شیفتش را روی «صفِ بازبینی» کار می‌کند هرگز به آن نمی‌رسید. این‌جا در هدر
                      است، پس روی هر ۱۱۹ صفحه هست.
                      یک دکمه، دو کار — چون خواسته همین بود: منوها جمع می‌شوند و مرورگر هم تمام‌صفحه
                      می‌شود. `requestFullscreen` به ژستِ کاربر نیاز دارد و همین کلیک آن ژست است؛ اگر
                      مرورگر یا سیاستِ سازمانی ردش کند، حالتِ تمرکز به‌تنهایی کار می‌کند و چیزی نمی‌شکند.
                      راهِ برگشت این‌جا نیست و نمی‌تواند باشد: در حالتِ تمرکز خودِ همین هدر پنهان
                      می‌شود. چیپِ «نمایش منو» در `AppShell.vue` همیشه روی صفحه می‌ماند و هر دو را
                      با هم برمی‌گرداند — و کلیدِ F هم همان کار را می‌کند.
                    -->
                    <button
                        type="button"
                        class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-gray-200 text-gray-500 transition hover:bg-gray-50 hover:text-gray-700 dark:border-gray-800 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-200"
                        aria-label="حالت تمرکز — جمع‌کردن منوها و تمام‌صفحه"
                        title="جمع‌کردن منو و نوار بالا و رفتن به تمام‌صفحه (کلید F)"
                        data-testid="header-focus-mode"
                        @click="enterFocusMode"
                    >
                        <Maximize2 class="h-4 w-4" aria-hidden="true"/>
                    </button>
                    <ThemeToggler class="header-tool"/>
                    <!-- Corrected after checking the endpoint rather than assuming it: /notifications/feed
                         carries no permission middleware and returns 200 to any admin — but it is NOT a
                         leak, because AdminNotificationFeedController gates each of its six sections
                         against the caller's own grants, so an external reviewer receives only the
                         review-queue section. The bell is hidden here for a product reason instead: a
                         contracted reviewer works a claimed queue, not an operational backlog. -->
                    <NotificationMenu v-if="can('notifications.read')"/>
                </div>
                <UserMenu class="border-s border-gray-200 ps-3 dark:border-gray-800"/>
            </div>
        </div>
    </header>
</template>

<script setup>
import {computed, ref} from 'vue'
import {useRoute} from 'vue-router'
import {Maximize2} from 'lucide-vue-next'
import {useSidebar} from '@/composables/useSidebar'
import {useFocusMode} from '@/composables/useFocusMode'
import {usePermission} from '@/composables/usePermission'
import ThemeToggler from '../common/ThemeToggler.vue'
import SearchBar from './header/SearchBar.vue'
import HeaderLogo from './header/HeaderLogo.vue'
import NotificationMenu from './header/NotificationMenu.vue'
import UserMenu from './header/UserMenu.vue'
import {sectionOf} from './navigation'

const route = useRoute()
const {toggleSidebar, toggleMobileSidebar, isMobileOpen} = useSidebar()
const {can} = usePermission()
const {enterBoth} = useFocusMode()

/**
 * Both, in one gesture, because that is the request: fold the chrome AND take the screen.
 *
 * The pairing lives in `useFocusMode` rather than here, so this button and the escape chip in AppShell
 * cannot drift apart about what «both» means — and so Esc, which leaves fullscreen without telling the
 * app, unwinds the same pair instead of stranding the operator in a page with no chrome and no way out.
 *
 * Entering never LEAVES here; leaving is the chip's job, and the chip is the only control on screen once
 * this header is hidden.
 */
const enterFocusMode = () => enterBoth()

/**
 * «{group} › {accordion} › {page}», with every empty part dropped.
 *
 * The page's own name is `meta.title` — the same string as its `<h1>`, its browser tab and the sidebar
 * row, since §14.5 N6 — and the section comes from the one navigation tree. A detail page inherits the
 * section of the list it came from (`sectionOf` walks up the path), so `/question-bank/questions/AB12`
 * says «محتوای آموزشی › جزئیات سؤال» rather than nothing.
 */
const fullLocationLine = computed(() => {
    if (route.meta?.public) return []
    const where = sectionOf(route.path)

    return [where?.group, where?.accordion, route.meta?.title].filter(Boolean)
})
// Keep the nearest section and current page visible; retain the complete path in the tooltip.
const locationLine = computed(() => {
    const parts = fullLocationLine.value
    const page = parts.at(-1)
    const section = parts.slice(0, -1).reverse().find(part => part !== page)
    return [section, page].filter(Boolean)
})

const handleToggle = () => {
    if (window.innerWidth >= 1024) {
        toggleSidebar()
    } else {
        toggleMobileSidebar()
    }
}

// const dropdownOpen = ref(false)
// const notifying = ref(false)

// const toggleDropdown = () => {
//     dropdownOpen.value = !dropdownOpen.value
//     notifying.value = false
// }

const isApplicationMenuOpen = ref(false)

const toggleApplicationMenu = () => {
    isApplicationMenuOpen.value = !isApplicationMenuOpen.value
}
</script>

<style scoped>
.header-search { flex: 1 1 0%; }
.header-tools > button,
.header-tools :deep(.relative > button:first-child) {
    border-color: transparent;
    border-radius: 0.5rem;
    background-color: transparent;
}
.header-tools > button:hover,
.header-tools :deep(.relative > button:first-child:hover) {
    @apply bg-gray-100 dark:bg-gray-800;
}
@media (min-width: 1024px) {
    .header-breadcrumb { order: 1; flex: 1 1 0%; }
    .header-breadcrumb > span:not(:last-child) { flex-shrink: 2; }
    .header-breadcrumb > span:last-child { flex-shrink: 1; }
    .header-search { order: 2; flex: 0 1 320px; min-width: 190px; }
}
</style>
